'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _weakMap = require('babel-runtime/core-js/weak-map');

var _weakMap2 = _interopRequireDefault(_weakMap);

var _callbackNames = require('./callback-names');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var privateData = new _weakMap2.default();
var callbacks = new _weakMap2.default();

var executeThenableCallback = function executeThenableCallback(_ref) {
  var registeredCallbacks = _ref.registeredCallbacks,
      originalCallbackArguments = _ref.originalCallbackArguments;
  return new _promise2.default(function (resolve, reject) {
    var callback = registeredCallbacks.pop();

    var returnValue = callback.apply(undefined, (0, _toConsumableArray3.default)(originalCallbackArguments));

    if (returnValue && returnValue.then) {
      returnValue.then(function (result) {
        if (registeredCallbacks.length) {
          executeThenableCallback({ registeredCallbacks: registeredCallbacks, originalCallbackArguments: originalCallbackArguments }).then(resolve, reject);
        } else {
          resolve(result);
        }
      }).catch(function (error) {
        return reject(error);
      });
    } else if (returnValue === false) {
      reject();
    } else if (registeredCallbacks.length) {
      executeThenableCallback({ registeredCallbacks: registeredCallbacks, originalCallbackArguments: originalCallbackArguments }).then(resolve, reject);
    } else {
      resolve();
    }
  });
};

var executeThenableCallbacks = function executeThenableCallbacks(_ref2) {
  var registeredCallbacks = _ref2.registeredCallbacks,
      originalCallbackArguments = _ref2.originalCallbackArguments;

  if (registeredCallbacks.length) {
    return executeThenableCallback({
      registeredCallbacks: (0, _assign2.default)([], registeredCallbacks).reverse(),
      originalCallbackArguments: originalCallbackArguments
    });
  }

  return _promise2.default.resolve();
};

var getProxyFunction = function getProxyFunction(_ref3) {
  var name = _ref3.name;

  var proxyClassContext = this;

  return function () {
    for (var _len = arguments.length, originalCallbackArguments = Array(_len), _key = 0; _key < _len; _key++) {
      originalCallbackArguments[_key] = arguments[_key];
    }

    var isThenable = _callbackNames.thenable.indexOf(name) >= 0;
    var registeredCallbacks = callbacks.get(proxyClassContext);
    var callbackReturnValue = void 0;

    if (isThenable) {
      callbackReturnValue = executeThenableCallbacks({ registeredCallbacks: registeredCallbacks, originalCallbackArguments: originalCallbackArguments });
    } else {
      (0, _assign2.default)([], registeredCallbacks).every(function (callback) {
        var returnValue = callback.apply(undefined, originalCallbackArguments);

        callbackReturnValue = returnValue;

        return returnValue !== false;
      });
    }

    return callbackReturnValue;
  };
};

var CallbackProxy = function () {
  function CallbackProxy(name) {
    (0, _classCallCheck3.default)(this, CallbackProxy);

    callbacks.set(this, []);

    privateData.set(this, {
      name: name,
      proxyFunction: getProxyFunction.call(this, { name: name })
    });
  }

  (0, _createClass3.default)(CallbackProxy, [{
    key: 'add',
    value: function add(callback) {
      callbacks.get(this).push(callback);
    }
  }, {
    key: 'remove',
    value: function remove(callback) {
      var index = callbacks.get(this).indexOf(callback);
      if (index >= 0) {
        callbacks.get(this).splice(index, 1);
      }
    }
  }, {
    key: 'name',
    get: function get() {
      return privateData.get(this).name;
    }
  }, {
    key: 'proxyFunction',
    get: function get() {
      return privateData.get(this).proxyFunction;
    }
  }]);
  return CallbackProxy;
}();

exports.default = CallbackProxy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FineUploader/callback-proxy.js
// module id = 2007
// module chunks = 1